/** Rejections retain either the original text or a structured candidate document. */
export function rejectedCaptureText(raw: unknown): string {
  if (typeof raw === 'string') return raw;
  if (raw == null) return '';
  return JSON.stringify(raw, null, 2) ?? '';
}
